module.exports = __webpack_public_path__ + "static/media/CitywideGathering.f53aaccf.png";